import { render, staticRenderFns } from "./DimensionInput.vue?vue&type=template&id=45157474&scoped=true&"
import script from "./DimensionInput.vue?vue&type=script&lang=js&"
export * from "./DimensionInput.vue?vue&type=script&lang=js&"
import style0 from "./DimensionInput.vue?vue&type=style&index=0&id=45157474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45157474",
  null
  
)

export default component.exports